import { lazy, Suspense } from "react";

import { LoadingIndicatorFullPage } from "../../../cc-ui/components";

const ApprenticeshipEnrollPage = lazy(() =>
  import("./ApprenticeshipEnrollPage").then((module) => ({ default: module.ApprenticeshipEnrollPage })),
);

export function ApprenticeshipEnrollAsync() {
  return (
    <Suspense fallback={<LoadingIndicatorFullPage open />}>
      <ApprenticeshipEnrollPage />
    </Suspense>
  );
}
